export const WORKSTATION = 'WORKSTATION';
export const PRINTER = 'printer';
export const SCALE = 'scale';
export const DIMENSIONALIZER = 'dimensionalizer';
export const ZPL_SETTING_NAME = 'LabelFileType';
export const ZPL_FILE_TYPE = 'ZPLII';
export const PDF_FILE_TYPE = 'PDF';
export const labelFileTypeValues = [PDF_FILE_TYPE, ZPL_FILE_TYPE];
export const checkBoxFields = ['zplInvert', 'zplPrintSpeedRemoval'];
export const selectFields = { model: ['110', '125', '150', '225', '100L'] };

export const printerZplFields = ['zplChunkSize', 'zplPrintSpeedRemoval', 'zplPrintSpeed', 'zplInvert'];

export const scaleFields = [
  'ssTimeout',
  'deviceTimeout',
  'readWait',
  'retries',
  'weight1Byte',
  'weight2Byte',
  'weight1Factor',
  'weight2Factor',
];

export const dimensionalizerFields = ['model', 'host', 'port'];

export const printerZplDefaults = {
  zplChunkSize: 5,
  zplPrintSpeed: 4,
  zplInvert: false,
  zplPrintSpeedRemoval: false,
};

export const scaleDefaults = {
  retries: 10,
  readWait: 600,
  deviceTimeout: 2000,
  ssTimeout: 3000,
  weight1Byte: 4,
  weight2Byte: 5,
  weight1Factor: 1,
  weight2Factor: 1,
};

export const highCapModeConfig = {
  weight1Factor: 0.1,
  weight2Factor: 0.1,
};

export const getFieldsByDeviceType = {
  [WORKSTATION]: [],
  [SCALE]: scaleFields,
  [PRINTER]: printerZplFields,
  [DIMENSIONALIZER]: dimensionalizerFields,
};

export const PRINTER_OR_SCALE_NAME_FIELD = 'name';
export const WORKSTATION_NAME_FIELD = 'description';
export const DISABLED_CHECKBOX_NAME = 'disabled';
export const SHARED_CHECKBOX_NAME = 'shared';
